'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashBoardTab = require('./dashBoardTab.html');

var _dashBoardTab2 = _interopRequireDefault(_dashBoardTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dashBoardTab = {
    bindings: {
        init: '=',
        search: '=',
        searchText: '=',
        isLoading: '=?'
    },
    template: _dashBoardTab2.default,
    controller: function controller($ionicLoading, $scope, ApiDashboard, ApiCampaigns, $filter, $rootScope, filterHistory) {
        var _this = this;

        this.$ionicLoading = $ionicLoading;
        this.$scope = $scope;
        this.ApiDashboard = ApiDashboard;
        this.ApiCampaigns = ApiCampaigns;
        this.campaigns = [];
        this.loading = [];
        this.campaignType = 'CAMPAIGN';
        this.campaignLoading = false;
        this.moreCampaigns = true;
        this.totalRecordCount = 0;
        this.translateFilter = $filter('translate');
        this.$rootScope = $rootScope;
        this.filterHistory = filterHistory;
        this.promises = [];
        this.filterParameter = {
            searchText: undefined,
            firstQueryResult: undefined
        };

        this.$onInit = function () {
            _this.getCurrencyList();
            _this.getRecordCount();
            _this.init(false);
        };

        this.init = function (pullToRefresh) {
            _this.pullToRefresh = pullToRefresh;
            _this.preLoadFilter();
            _this.getDashboardCampaigns();
        };

        this.getRecordCount = function () {
            _this.showLoading();
            _this.ApiDashboard.getCampaignCount(_this.filterParameter).then(function (count) {
                _this.hideIonicLoading();
                if (!count) return;
                _this.totalRecordCount = count;
                _this.displayShowMoreButtonIfExists();
            });
        };

        this.refreshComplete = function () {
            if (!_this.campaignLoading && !_this.motherCampaignLoading) {
                _this.$rootScope.$broadcast('scroll.refreshComplete');
            }
        };

        this.getCurrencyList = function () {
            _this.showLoading();
            _this.ApiCampaigns.retrieveCurrencyList().then(function (currencyObjects) {
                _this.hideIonicLoading();
                if (!currencyObjects) return;
                _this.currencies = currencyObjects.data;
            });
        };

        this.getDashboardCampaigns = function () {
            _this.showLoading();
            _this.ApiDashboard.getDashboardCampaigns(_this.filterParameter).then(function (result) {
                _this.hideIonicLoading();
                _this.populateCampaignDetails(result);
                _this.campaigns = result || [];
                _this.campaignLoading = false;
                _this.displayShowMoreButtonIfExists();
                if (_this.pullToRefresh) {
                    _this.refreshComplete();
                }
            });
        };

        this.getMoreCampaigns = function () {
            _this.campaignLoading = true;
            _this.filterParameter.firstQueryResult = _this.campaigns && _this.campaigns.length;
            _this.ApiDashboard.getDashboardCampaigns(_this.filterParameter).then(function (campaigns) {
                if (!campaigns) {
                    _this.moreCampaigns = false;
                } else {
                    _this.populateCampaignDetails(campaigns);
                    _this.campaigns = _this.campaigns.concat(campaigns);
                    _this.$scope.$broadcast('scroll.infiniteScrollComplete');
                    _this.displayShowMoreButtonIfExists();
                }
                _this.campaignLoading = false;
            });
        };

        this.showLoading = function () {
            _this.loading.push(1);
            _this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        };

        this.hideIonicLoading = function () {
            var self = _this;
            self.loading.pop();
            if (self.loading.length <= 0) {
                self.$ionicLoading.hide();
            }
        };

        this.getCurrencySymbol = function (currencyShortName) {
            if (!_this.currencies || !currencyShortName) {
                return '';
            }
            var matchingCurrency;
            _this.currencies.forEach(function (currency) {
                if (currency.shortName === currencyShortName) {
                    matchingCurrency = currency;
                }
            });
            return matchingCurrency && matchingCurrency.symbol;
        };

        this.populateCampaignDetails = function (campaigns) {
            var self = _this;
            angular.forEach(campaigns, function (campaign) {
                if (campaign.campaign) {
                    campaign.currency = angular.copy(self.getCurrencySymbol(campaign.campaign.campaignCurrency));
                    campaign.campaign.investmentLabels = [self.translateFilter('MISSING_INVESTMENT'), self.translateFilter('POTENTIAL_INVESTMENT'), self.translateFilter('COMMITED_INVESTMENT')];
                    campaign.campaign.investmentData = [];
                    campaign.campaign.investmentData.push(_this.calculateMissingInvestment(campaign.campaign));
                    campaign.campaign.investmentData.push(campaign.campaign.promisedInvestment);
                    campaign.campaign.investmentData.push(campaign.campaign.confirmedInvestment);

                    if (campaign.numOfContactsByLevelOfInterest) {
                        campaign.numOfContactsByLevelOfInterest.lOILabels = ['No', 'Selected', 'Pending', 'Low', 'Resubmission Later', 'Decision via Gatekeeper / Parent / Advisor', 'General', 'MP Meeting', 'Strong interest', 'Due Diligence', 'Soft Circled', 'Committed'];
                        campaign.numOfContactsByLevelOfInterest.lOIData = [];
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.NO);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.SELECTED);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.PENDING);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.LOW);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.RESUBMISSION_LATER);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.DECISION_VIA_GATEKEEPER_ADVISOR_PARENT);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.GENERAL);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.MP_MEETING);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.STRONG_INTEREST);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.DUE_DILIGENCE);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.SOFT_CIRCLED);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.COMMITED);
                    }
                }
            });
        };

        this.calculateMissingInvestment = function (campaign) {
            var missingInvestment = campaign.targetInvestment - campaign.promisedInvestment - campaign.confirmedInvestment;
            if (missingInvestment < 0) {
                return 0;
            } else {
                return missingInvestment;
            }
        };

        this.preLoadFilter = function () {
            var filter = _this.filterHistory.readFilter('dashboard');
            if (filter) {
                filter.firstQueryResult = undefined;
                _this.filterParameter = filter;
                if (_this.filterParameter.searchText) {
                    _this.searchText = _this.filterParameter.searchText;
                }
            } else {
                _this.filterParameter = {
                    searchText: undefined,
                    firstQueryResult: undefined
                };
            }
        };

        this.search = function (searchText) {
            _this.searchText = searchText;
            _this.filterParameter.searchText = searchText;
            _this.filterParameter.firstQueryResult = undefined;
            _this.getRecordCount();
            _this.getDashboardCampaigns();
            _this.filterHistory.saveFilter(angular.copy(_this.filterParameter), 'dashboard');
        };

        this.displayShowMoreButtonIfExists = function () {
            // console.log('> moreCampaigns, totalRecordCount, campaigns.length', this.moreCampaigns, this.totalRecordCount, this.campaigns.length);
            _this.moreCampaigns = _this.totalRecordCount > _this.campaigns.length;
        };
    }
};

exports.default = dashBoardTab;


/** WEBPACK FOOTER **
 ** ./src/app/directives/dashBoardTab/dashBoardTab.js
 **/